export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-4xl mx-auto">
          <div className="flex-shrink-0 w-[200px] h-[400px] md:w-[240px] md:h-[480px] rounded-2xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20manga%20reading%20app%20interface%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20clean%20modern%20UI%20design%20with%20comic%20panels%20and%20reading%20controls%2C%20Japanese%20manga%20aesthetic%2C%20soft%20gradient%20background%2C%20minimalist%20flat%20design%2C%20friendly%20and%20inviting%20app%20screenshot%20style&width=480&height=960&seq=app-mockup-01&orientation=portrait"
              alt="迷妹漫画APP界面"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-sm font-medium mb-6">
              <i className="ri-smartphone-line"></i>
              <span>随时随地畅享阅读</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              APP下载
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto lg:mx-0 mb-6 leading-relaxed">
              迷妹漫画APP专为移动阅读优化，支持下拉式竖屏滚动阅读、离线缓存、夜间模式和智能书签。不论地铁通勤还是睡前放松，打开APP即刻沉浸在漫画世界中。更流畅的阅读体验，更低的数据消耗，还有专属APP用户的每日推送和福利活动。
            </p>

            <div className="flex flex-wrap gap-3 items-center justify-center lg:justify-start mb-6">
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-background-100">
                <i className="ri-apple-fill text-foreground-600"></i>
                <span className="text-xs text-foreground-600">iOS版</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-background-100">
                <i className="ri-android-fill text-foreground-600"></i>
                <span className="text-xs text-foreground-600">Android版</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-background-100">
                <i className="ri-computer-line text-foreground-600"></i>
                <span className="text-xs text-foreground-600">网页版</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 items-center justify-center lg:justify-start">
              <a href="#app" className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-download-line"></i>
                下载iOS版
              </a>
              <a href="#app" className="inline-flex items-center gap-2 px-8 py-3 bg-secondary-500 text-background-50 font-medium rounded-full hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-download-line"></i>
                下载Android版
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}